import { useEffect, useState } from 'react'

import { Loading } from '@hhgtech/hhg-components'
import { Box, rem } from '@mantine/core'

import { callApiNew } from 'api/axios'
import { formatArticle } from 'api/dataTransform'
import { PATHS } from 'api/paths'
import { ArticleCardWrapper } from 'components/molecules/articleCardWrapper'
import { useIsMobile } from 'hooks/useIsMobile'
import { Article } from 'interfaces/types'

type Props = {
  inView: boolean
  loadIds: string[] | number[]
  articles?: Article[]
  dataTrackingCommon?: any
}

export const LazyItem = ({
  articles: articlesProp = [],
  inView,
  loadIds = [],
  dataTrackingCommon,
}: Props) => {
  const isMobile = useIsMobile()
  const [articles, setArticles] = useState<Article[]>(articlesProp)

  useEffect(() => {
    inView &&
      articlesProp.length === 0 &&
      loadIds.length > 0 &&
      (async () => {
        const res = await callApiNew(PATHS.ARTICLE.GET_ARTICLES, {
          params: {
            ids: loadIds.join(','),
          },
        })
        setArticles((res?.data?.posts || []).map(formatArticle))
      })()
  }, [inView])

  return articles.length === 0 ? (
    <Loading />
  ) : (
    <Box
      sx={(theme) => ({
        [theme.fn.smallerThan('sm')]: {
          display: 'flex',
          flexDirection: 'column',
          '.card-item': {
            borderTop: `1px solid ${theme.colors.neutral[1]}`,
            '&:first-of-type': {
              borderTop: 0,
              paddingTop: 0,
            },
          },
        },
        [theme.fn.largerThan('sm')]: {
          display: 'grid',
          gridTemplateColumns: `repeat(4, 1fr)`,
          gap: rem(24),
        },
      })}
    >
      {articles.slice(0, isMobile ? 4 : 8).map((article, idx) => (
        <ArticleCardWrapper
          article={article}
          key={String(idx)}
          className="card-item"
          {...dataTrackingCommon(article)}
          type="author"
          size="sm"
          direction={isMobile ? 'horizontal' : 'vertical'}
          hideBookmark
        />
      ))}
    </Box>
  )
}
